import { connect } from 'react-redux';
import withPGTranslation from '../../config/withPGTranslation';
import GeneralPopup from './general_popup';

const mapStateToProps = ({ application: { dynamicConfig } }) => ({
  url: dynamicConfig?.url
});

export default connect(mapStateToProps)(withPGTranslation(GeneralPopup));
